import { getSupabaseClient } from '../supabaseClient';

/**
 * Cleans up calls_analysis_onboarding table when brain settings or categories are deleted.
 * Sets brain_setting_id to null and covered to false for affected rows.
 * 
 * @param {string} accountId - The account ID
 * @param {string} businessType - The business type for supabase client
 * @param {string} settingId - The brain setting ID (optional)
 * @param {string} categoryId - The brain category ID (optional)
 * @returns {Promise<void>}
 */
export const cleanupCallsAnalysisOnboarding = async (accountId, businessType, settingId = null, categoryId = null) => {
  const supabase = getSupabaseClient(businessType);

  try {
    // Case 1: Deleting a specific setting
    if (settingId) {
      const { error } = await supabase
        .from('calls_analysis_onboarding')
        .update({
          brain_setting_id: null,
          covered: false
        })
        .eq('account_id', accountId)
        .eq('brain_setting_id', settingId);

      if (error) throw error;
    }

    // Case 2: Deleting a category - need to find all settings in that category first
    if (categoryId) {
      // Get all settings in the category
      const { data: categorySettings, error: settingsError } = await supabase
        .from('brain_settings')
        .select('id')
        .eq('category_id', categoryId);

      if (settingsError) throw settingsError;

      // If there are settings in the category, update onboarding records
      if (categorySettings && categorySettings.length > 0) {
        const settingIds = categorySettings.map(setting => setting.id);

        const { error: updateError } = await supabase
          .from('calls_analysis_onboarding')
          .update({
            brain_setting_id: null,
            covered: false
          })
          .eq('account_id', accountId)
          .in('brain_setting_id', settingIds);

        if (updateError) throw updateError;
      }
    }
  } catch (error) {
    console.error('Error cleaning up calls_analysis_onboarding:', error);
    throw error;
  }
}; 